import {
    GET_STORES,
    DELETE_STORE,
    ADD_STORE,
    STORE_LOADING
} from "../../actions/types";

const initalizeState = {
    stores: [],
    loading: true,
    error: {},
    updatedAt: new Date(),
};

export default function(state = initalizeState, action) {
    const { type, payload } = action;
    switch (type) {
        case STORE_LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_STORES:
            return {
                ...state,
                stores: payload.stores,
                loading: false
            };
        case ADD_STORE:
            return {
                ...state,
                stores: [payload.store, ...state.stores],
                loading: false,
                updatedAt: new Date(),
            };
        case DELETE_STORE:
            return {
                ...state,
                stores: state.stores.filter(store => store.id !== payload),
                loading: false,
                updatedAt: new Date(),
            };
        default:
            return state;
    }
}
